import React, { createContext, useContext } from 'react';
import { ComputeResourceDiscoveryApi } from '../../api';
import { CRDGCPConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { useRefreshContext } from '../RefreshContext';

interface GcpContextProps {
  api: ComputeResourceDiscoveryApi;
  gcpConfigs: CRDGCPConfig[];
  projectCode: string;
  refreshContext?: ReturnType<typeof useRefreshContext>;
}

const GcpContext = createContext<GcpContextProps | undefined>(undefined);

export const useGcpContext = () => {
  const context = useContext(GcpContext);
  if (!context) {
    throw new Error('GcpContext must be used within a GcpProvider');
  }
  return context;
};

export const GcpContextProvider: React.FC<
  Omit<GcpContextProps, 'refreshContext'> & { children: React.ReactNode }
> = ({ api, gcpConfigs, projectCode, children }) => {
  const refreshContext = useRefreshContext();

  return (
    <GcpContext.Provider
      value={{
        api,
        gcpConfigs,
        projectCode,
        refreshContext,
      }}
    >
      {children}
    </GcpContext.Provider>
  );
};
